import { z, ZodTypeAny } from 'zod';

import { FileSchema } from '../../types/File.schema';

const Files: {
    validator: ZodTypeAny;
} = {
    validator: z.array(FileSchema),
};

export { Files };
